import { categoryCodeTab } from '@/layout/state/state';
import datasetTabTemplate from './datasetTabTemplate';

export default {
  ...datasetTabTemplate(['datasets', 'dataset'], ({ datasets }) => datasets.create),
  componentState: ({ args, url }) => categoryCodeTab(url, args[4]),
};
